<template>
  <common-modal
    :hideFooter="true"
    :hideHeader="true"
    :name="modalName"
    height="auto"
    width="80%"
    :clickNotClose="true"
  >
    <template #modal-body>
      <div class="detail-event">
        <div class="actions-bar flex justify-between items-center w-full">
          <h3 class="font-medium text-xl text-gray-700">
            {{ eventData.title }}
          </h3>
          <div class="flex items-center">
            <span
              v-if="
                isScheduleEvent && eventData.eventType !== EVENT_TYPES.canceled
              "
              :class="
                eventData.attendance ? 'text-[#08980E]' : 'text-[#D3660A]'
              "
              class="text-base font-semibold mx-4"
            >
              <i
                :class="eventData.attendance ? 'fa-check-double' : 'fa-check'"
                class="fas"
              ></i>
              {{
                eventData.attendance
                  ? $t("common.completed")
                  : $t("common.uncompleted")
              }}
            </span>
            <div class="actions">
              <md-button
                v-if="
                  canViewAttendances &&
                    !isMeetingEvent &&
                    eventData.eventType !== EVENT_TYPES.canceled
                "
                class="md-simple md-just-icon md-icon-button md-info"
                @click.native="triggerGoToAttendance"
              >
                <md-tooltip md-direction="top">Attendance 1</md-tooltip>
                <i class="fas fa-user-check"></i>
              </md-button>
              <md-button
                v-if="
                  canEditEvent &&
                    !isMeetingEvent &&
                    eventData.eventType !== EVENT_TYPES.canceled
                "
                class="ml-2 md-simple md-just-icon md-icon-button md-success"
                @click.native="triggerEventModification"
              >
                <md-tooltip md-direction="top">Edit</md-tooltip>
                <md-icon>edit</md-icon>
              </md-button>
              <md-button
                v-if="isMeetingEvent"
                class="ml-2 md-simple md-just-icon md-icon-button md-info"
                @click.native="triggerEventReport"
              >
                <md-tooltip md-direction="top">Attendance</md-tooltip>
                <i class="fas fa-user-check"></i>
              </md-button>

              <!--              TODO: Cancel in Phase 3-->
              <!--              <md-button
                              v-if="isMeetingEvent"
                              class="ml-2 md-simple md-just-icon md-icon-button md-danger"
                              @click.native="triggerEventCancellation"
                            >
                              <md-tooltip md-direction="top">Cancel</md-tooltip>
                              <md-icon>block</md-icon>
                            </md-button>-->
              <md-button
                v-if="canDeleteEvent"
                class="ml-2 md-simple md-just-icon md-icon-button md-danger"
                @click.native="triggerEventDeletion"
              >
                <md-tooltip md-direction="top">Delete</md-tooltip>
                <md-icon>delete_forever</md-icon>
              </md-button>
              <md-button
                class="ml-2 md-simple md-just-icon md-icon-button md-danger"
                @click.native="close"
              >
                <md-tooltip md-direction="top">Close</md-tooltip>
                <md-icon>close</md-icon>
              </md-button>
            </div>
          </div>
        </div>
        <div
          v-if="isMeetingEvent || eventData.eventType === EVENT_TYPES.canceled"
          class="event-detail mt-2"
        >
          <div class="lg:hidden my-4">
            <span
              :style="{ backgroundColor: eventData.backgroundColor }"
              class="event-type text-white font-medium"
            >
              {{ eventData.category }}
            </span>
          </div>
          <div class="event-detail__line mt-2 items-center justify-between">
            <p class="font-medium">
              <span v-if="eventData.type === 'daily'">
                {{ $t("calendar.meeting.daily") }}
              </span>
              <span v-else-if="eventData.type === 'weekly'">
                {{ $t("calendar.meeting.weekly") }}
              </span>
              <span v-else>{{ $t("calendar.meeting.schedule") }}</span>
            </p>
            <p
              :style="{ backgroundColor: eventData.backgroundColor }"
              class="event-type text-white font-medium hidden lg:block"
            >
              {{
                eventData.eventType === EVENT_TYPES.canceled
                  ? $t("schedule.canceled_meeting")
                  : eventData.category
              }}
            </p>
          </div>
          <div class="event-detail__line mt-2 items-center justify-between">
            <div class="flex items-center">
              <md-icon class="icon"> date_range</md-icon>
              <p class="event-detail__range-date">
                {{ eventData.rangeDateText }}
                <span class="event-detail__range-time ml-1">{{
                  eventData.rangeTimeText
                }}</span>
              </p>
            </div>

            <p class="text-success">
              <md-icon class="icon text-success"> lock</md-icon>
              {{ eventData.password }}
            </p>
          </div>
          <div class="event-detail__line mt-2 items-center justify-between">
            <div class="flex items-center">
              <md-icon class="icon"> timer</md-icon>
              <p>
                {{
                  $t("calendar.meeting.duration", {
                    duration: eventData.duration
                  })
                }}
              </p>
            </div>

            <p>
              {{ $t("calendar.meeting.meeting_id") }}: {{ eventData.meetingID }}
            </p>
          </div>
          <div class="event-detail__line mt-2">
            <md-icon class="icon">person</md-icon>
            <p>{{ $t("calendar.meeting.host") }}: {{ eventData.host }}</p>
          </div>
          <div
            v-if="eventData.eventType !== EVENT_TYPES.canceled"
            class="event-detail__line mt-2"
          >
            <md-icon class="icon">location_on</md-icon>
            <p>
              {{ $t("calendar.meeting.join_with_link") }}:
              <a :href="eventData.link" target="_blank">{{ eventData.link }}</a>
            </p>
          </div>
          <template v-if="(vrcUrls || []).length > 0">
            <div
              class="event-detail__line mt-2 flex items-center flex-wrap"
            >
              <md-icon class="icon">play_circle</md-icon>
              <p
                v-for="(item, index) in vrcUrls"
                :key="index"
                class="flex items-center"
              >
                <a :href="item" target="_blank"
                  >{{ $t("calendar.meeting.view_record") + " " + (index + 1) }}
                </a>
                <md-button
                  v-if="canDeleteVCR"
                  class="md-simple md-icon-button md-danger"
                  @click.native="triggerEventVCRDeletion(item)"
                >
                  <md-icon>delete_forever</md-icon>
                </md-button>
                <span
                  v-if="index < vrcUrls.length - 1"
                  v-html="','"
                  class="mr-1"
                >
                </span>
              </p>
            </div>

          </template>
        <div style="display: flex;">
          <div v-if="isAllowUploadVcr" style="width: 15%;">
            <button type="button" class="upload-file-btn" @click="triggerFileUpload"> Upload File </button>
            <input multiple type="file" ref="fileInput" @change="handleFileChange" style="display: none;" />
          </div>
          <!-- <p>{{ isShowFileUploadingTags }}</p> -->
          <div v-if="isShowFileUploadingTags" style="width: 60%;">
            <file-uploading v-for="(file, renamedName) in getUploadingFiles" :key="renamedName" class="mb-5" :fileName="file.originName"></file-uploading>
          </div>
        </div>
        </div>
        <div v-else class="event-detail mt-2">
          <div class="lg:hidden my-4">
            <span
              :style="{ backgroundColor: eventData.backgroundColor }"
              class="event-type text-white font-medium"
            >
              {{ eventData.category }}
            </span>
          </div>
          <div class="event-detail__line mt-2 items-center justify-between">
            <div class="flex items-center">
              <md-icon class="icon">date_range</md-icon>
              <p class="event-detail__range-date">
                {{ eventData.rangeDateText }}
                <span class="event-detail__range-time ml-1">{{
                  eventData.rangeTimeText
                }}</span>
              </p>
            </div>

            <p
              :style="{ backgroundColor: eventData.backgroundColor }"
              class="event-type text-white font-medium hidden lg:block"
            >
              {{ eventData.category }}
            </p>
          </div>
          <div v-if="isScheduleEvent" class="event-detail__line mt-2">
            <md-icon class="icon">record_voice_over</md-icon>
            <p>
              {{ $t("schedule.primary_teacher") }}:
              {{ eventData.teacherUsername }}
            </p>
          </div>
          <div class="event-detail__line mt-2">
            <md-icon class="icon">location_on</md-icon>
            <p>{{ $t("schedule.location") }}: {{ eventData.location }}</p>
          </div>
          <div class="event-detail__line mt-2 max-w-4/5">
            <md-icon class="icon">description</md-icon>
            <p class="max-w-[90%] break-words">
              {{ $t("common.description") }}: {{ eventData.description }}
            </p>
          </div>
          <div class="event-detail__line mt-2">
            <md-icon class="icon">person</md-icon>
            <p>{{ $t("schedule.creator") }}: {{ eventData.creatorUsername }}</p>
          </div>
        </div>
      </div>
    </template>
  </common-modal>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { EVENT_CATEGORIES, EVENT_TYPES } from "../event-utils";
import Role from "@/constants/Role";
import { mapGetters } from "vuex";
import { TEACHER_ASSIGNMENTS } from "@/constants";
import { Attendance, Calendar } from "@/constants/Permissions";
import {
  convertTimeByTimezone,
  getTimeString,
  isSameDate,
  subtractDayOfDate
} from "@/helpers/datetime-helper";
import { hasValidRole } from "@/helpers/role-helper";
import moment from "moment-timezone";
import { zoom_meeting_names } from "@/routes/routes";
import { service_paths } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import $axios from "@/helpers/axios-helper";
import { postFileToS3 } from "@/helpers/aws-s3";
import FileUploading from "./Common/FileUploading.vue";
import { store } from "@/store";

export default {
  components: {
    FileUploading
  },
  data() {
    return {
      linkViewRecord: [],
      modalName: "detail-event-modal",
      EVENT_TYPES,
      uploadingFiles: [],
      triggerGetUploadingFiles: 1
    };
  },
  props: ["selectedEvent"],
  inject: ["refetchEvents"],
  created() {
    store.commit("notify/setFileUploading", { relationId: 123})
  },
  computed: {
    eventData() {
      const isEmptyEvent = Object.keys(this.selectedEvent).length === 0;
      if (isEmptyEvent) {
        return {
          title: "",
          rangeDateText: "",
          rangeTimeText: "",
          backgroundColor: "",
          category: ""
        };
      }
      const eventInfo = cloneDeep(this.selectedEvent.event);
      const rangeTime = this.generateRangeTime(eventInfo);
      let categoryText =
        eventInfo.extendedProps.type === EVENT_TYPES.meetingEvent
          ? EVENT_CATEGORIES.meeting
          : EVENT_CATEGORIES[eventInfo.extendedProps?.category || "schedule"];

      const eventData = {
        title: eventInfo.title,
        rangeDateText: rangeTime.dateText,
        rangeTimeText: rangeTime.timeText,
        backgroundColor: eventInfo.backgroundColor,
        category: categoryText,
        location: eventInfo.extendedProps?.location,
        description: eventInfo.extendedProps?.description,
        creatorUsername: eventInfo.extendedProps?.user?.username,
        attendance: eventInfo.extendedProps?.attendances?.length,
        eventType: eventInfo.extendedProps?.type
      };

      // extend field for class schedule
      if (eventInfo.extendedProps?.category === "schedule") {
        const primaryTeacher = eventInfo.extendedProps?.class?.teachers?.find(
          teacher => teacher.assignment === TEACHER_ASSIGNMENTS.PRIMARY
        );

        eventData.teacherUsername = primaryTeacher?.users?.username;
      }

      const meetingDetail = eventInfo.extendedProps.zoom_meeting;
      if (
        this.isMeetingEvent ||
        eventInfo.extendedProps?.type === EVENT_TYPES.canceled
      ) {
        let hostInfo = meetingDetail?.host_zoom_meeting?.host;
        eventData.type = eventInfo.extendedProps.repeat || "schedule";
        eventData.host =
          hostInfo?.full_name +
          (hostInfo?.email ? " - " + hostInfo?.email : "");
        eventData.link = meetingDetail?.link_zoom;
        eventData.duration = meetingDetail?.duration;
        eventData.password = meetingDetail?.password;
        eventData.meetingID = meetingDetail?.pmi;
        eventData.attendance = !eventInfo.extendedProps?.attendances?.length;
        eventData.linkViewRecord = eventInfo.extendedProps?.record_url;
      }
      this.getVrcUrls(this.eventId);
      return eventData;
    },
    isScheduleEvent() {
      return this.selectedEvent?.event?.extendedProps?.category === "schedule";
    },
    isMeetingEvent() {
      return (
        this.selectedEvent?.event?.extendedProps.type ===
        EVENT_TYPES.meetingEvent
      );
    },
    ...mapGetters("user", {
      userRole: "role",
      userTz: "timezone"
    }),
    canViewAttendances() {
      return (
        this.$can(Attendance.actions.view, Attendance.subject) &&
        this.isScheduleEvent
      );
    },
    canEditEvent() {
      if (hasValidRole(this.userRole, Role.Teacher)) {
        return (
          this.$can(Calendar.actions.edit, Calendar.subject) &&
          this.isScheduleEvent
        );
      }

      return this.$can(Calendar.actions.edit, Calendar.subject);
    },
    canDeleteEvent() {
      return this.$can(Calendar.actions.delete, Calendar.subject);
    },
    canDeleteVCR() {
      if (hasValidRole(this.userRole, Role.Admin) && this.vrcUrls.length > 1) {
        return this.$can(Calendar.actions.delete, Calendar.subject);
      }
      return false;
    },
    eventId() {
      const eventData = this.selectedEvent?.event;
      return getId(eventData?.extendedProps);
    },
    vrcUrls() {
      if(this.linkViewRecord.length > 0)
        return this.linkViewRecord;
      return this.selectedEvent.event?.extendedProps?.record_url?.split(',') || [];
    },
    isShowFileUploadingTags() {
      return this.getUploadingFiles && this.getUploadingFiles.length > 0
    },
    getUploadingFiles(){
      let storedUploadingFiles = store.getters["notify/getFileUploadings"]
      if(this.triggerGetUploadingFiles && !storedUploadingFiles)
        return [];

      return storedUploadingFiles.filter(file => file.relationId == this.eventId);
    },
    isAllowUploadVcr(){
      // return this.$can(Calendar.actions.uploadVcr, Calendar.subject) || false;
      return hasValidRole(this.userRole, Role.Admin) || false;
    }
  },
  methods: {
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const files = event.target.files;
      if (files) {
        this.uploadFile(files);
      }
      event.target.value = null;
    },
    async uploadFile(files) {
      try{
        let fileUrls = new Array();
        let i = 0;
        for(const file of files) {
          let storedUploadingFile = {
            index: i,
            relationId: this.eventId,
            originName: file.name,
            storedName: `${file.name.split('.')[0]}_${Date.now()}.${file.name.split('.')[1]}`.replace(' ', '_'),
            type: file.type
          }
          store.commit("notify/setFileUploading", storedUploadingFile)
          this.triggerGetUploadingFiles++;

          this.wait(20);
          i++;
        };
        let storedUploadingFiles = this.getUploadingFiles;
        for(const storedUploadingFile of storedUploadingFiles){
          const fileBlob = new Blob([files[storedUploadingFile.index]], { type: storedUploadingFile.type });
          let renamedFile = new File([fileBlob], storedUploadingFile.storedName, { type: fileBlob.type})
          let fileUrl = await postFileToS3("record_vcr", renamedFile)
          fileUrls.push(fileUrl);
        }

        await this.saveFileUrl(fileUrls);
        this.close();
      }
      catch (error) {
        console.log("upload record vr error: ", error);
      } finally {
      }
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    open() {
      this.$modal.show(this.modalName);
    },
    close() {
      this.$modal.hide(this.modalName);
    },
    triggerGoToAttendance() {
      this.$router.push({
        path: "schedule/" + this.selectedEvent.event.id + "/attendance"
      });
    },
    generateRangeTime(event) {
      const userTz = this.userTz ?? moment.tz.guess();
      const startDate = event.start;
      const endDate = event.end;

      // refers: https://date-fns.org/v2.22.1/docs/format

      const startDateStr = getTimeString(startDate, userTz, "dddd, MMMM DD");
      const endDateStr = getTimeString(endDate, userTz, "dddd, MMMM DD");

      // FIX-ME: 00h is displayed 12h.
      const startTimeStr = getTimeString(startDate, userTz, "hh:mm a");
      const endTimeStr = getTimeString(endDate, userTz, "hh:mm a");

      const isAllDayEvent = event.allDay;
      const isInDayEvent =
        (isAllDayEvent && !event.end) || isSameDate(startDate, endDate);
      if (isInDayEvent) {
        if (isAllDayEvent) {
          return {
            dateText: `${startDateStr} (${this.$t("schedule.all_day")})`,
            timeText: ""
          };
        }
        return {
          dateText: startDateStr,
          timeText: `${startTimeStr} - ${endTimeStr}`
        };
      }

      if (isAllDayEvent) {
        return {
          dateText: `${startDateStr} - ${subtractDayOfDate(
            endDate,
            1,
            "dddd, MMMM DD"
          )} (${this.$t("schedule.all_day")})`,
          timeText: ""
        };
      }

      return {
        dateText: `${startTimeStr} ${startDateStr} - ${endTimeStr} ${endDateStr}`,
        timeText: ""
      };
    },
    triggerEventReport() {
      const zoomId = this.selectedEvent?.event?.extendedProps?.zoom_meeting_id;
      const eventInfo = cloneDeep(this.selectedEvent.event);
      const userTz = this.userTz ?? moment.tz.guess();
      const startDate = eventInfo.start;
      const startDateStr = getTimeString(startDate, userTz, "YYYY-MM-DD HH:mm");
      const dateOfUTC = convertTimeByTimezone(
        startDateStr,
        userTz,
        "Etc/UTC",
        "YYYY-MM-DD HH:mm"
      );
      if (!zoomId) return;
      const groupId = eventInfo?.extendedProps?.group;
      const route = this.$router.resolve({
        name: zoom_meeting_names.reportCalendar,
        params: { id: zoomId },
        query: {
          date: dateOfUTC,
          groupCalendarId: groupId
        }
      });
      window.open(route.href, "_blank");
    },
    triggerEventDeletion() {
      this.close();
      this.$emit("start-delete");
    },
    triggerEventVCRDeletion(vcr) {
      this.close();
      this.$emit("start-delete-vcr", vcr);
    },
    triggerEventModification() {
      this.close();
      this.$emit("start-modify");
    },
    triggerEventCancellation() {
      this.$emit("start-cancel");
    },
    async saveFileUrl(fileUrls){
      let storedUploadingFiles = store.getters["notify/getFileUploadings"];
      let firstFileNameArr = fileUrls[0].split('/');
      let firstFileName = firstFileNameArr[firstFileNameArr.length - 1];
      let eventId = storedUploadingFiles.filter(file => file.storedName == firstFileName)[0]?.relationId

      const path = `${service_paths.calendars}/add-vcr/${eventId}`;
      const payload = { fileUrls }
      await $axios.post(path, payload, { headers: await $axios.getHeaderCfg()}, "json", null, false)
                  .then(async () => {
                      await this.getVrcUrls(eventId);
                      fileUrls.forEach(url => {
                        let urlSplitArray = url.split('/');
                        let renamedFileName = urlSplitArray[urlSplitArray.length - 1];

                        let storedUploadedFileIndex = storedUploadingFiles.findIndex(file => {
                          return file.relationId == eventId && file.storedName == renamedFileName
                        })
                        store.commit("notify/removeFileUploaded", storedUploadedFileIndex);
                        this.triggerGetUploadingFiles++;
                      });
                      this.refetchEvents();
                      Message.success("Added VCR successfully!");
                    });
    },
    async getVrcUrls(eventId){
      const path = `${service_paths.calendars}/get-vcr-by-calendar-id/${eventId}`;
      try{
        await $axios.get(path, null, true, { headers: await $axios.getHeaderCfg()}, "json", null, false)
                  .then(response => {
                    if(response.status == 200){
                      let vcrUrls = (response.data.split(',') || []).filter(url => url); //just get urls are not empty
                      if(eventId == this.eventId){
                        this.linkViewRecord = vcrUrls;
                      }
                    }
                  });
      }
      catch(error){}
      finally{
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.event-detail__line {
  display: flex;
  align-items: flex-start;

  .icon {
    margin: 0 10px 0 0;
  }

  p {
    font-weight: 400;
  }
}

.event-type {
  padding: 7px;
  border-radius: 10px;

  font-size: 14px;
}

.upload-file-btn{
  padding: 7px;
  background-color: #47a44b;
  border-radius: 8px;
  color: whitesmoke;
}
</style>
